import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex border-b" }
const _hoisted_2 = { class: "-mb-px mr-1 cursor-pointer" }
const _hoisted_3 = { class: "bg-white inline-block border-l border-t border-r rounded-t py-2 px-4 text-blue-700 font-semibold" }
const _hoisted_4 = { class: "mr-1" }
const _hoisted_5 = { class: "bg-white inline-block py-2 px-4 text-blue-500 hover:text-blue-800 font-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "text-right"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "animate-spin material-icons text-lg text-op-teal mr-2" }, "schedule", -1)
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center m-4"
}
const _hoisted_9 = { class: "my-4 text-2xl text-current" }
const _hoisted_10 = { class: "my-4 text-xl text-current" }
const _hoisted_11 = { class: "max-w-xl mx-auto text-left p-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  type: "button",
  class: "bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow",
  disabled: ""
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "animate-spin material-icons text-lg text-op-teal mr-2" }, "schedule", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("> ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("menu.nftRequest")), 1)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: _ctx.localizedUrl('/nft')
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("menu.nftMinted")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    (_ctx.nftSyncing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("label.syncing")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.nftRequestPhotos)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("message.nftRequestTitle")), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("message.nftRequestDesc", {
            tokenName: _ctx.ContentsContract.authorityTokenName,
          })), 1),
            _createElementVNode("b", null, _toDisplayString(_ctx.$t("label.requestCount")) + " :", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.nftRequestPhotos.length) + " ", 1),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.tokenGate == 'noAccount')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.errorAccount")), 1)
                  ]))
                : (_ctx.tokenGate == 'invalidNetwork')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.invalidNetwork")) + " " + _toDisplayString(_ctx.ContentsContract.network), 1),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchToValidNetwork && _ctx.switchToValidNetwork(...args))),
                        class: "underline"
                      }, _toDisplayString(_ctx.$t("message.switchNetwork")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_ctx.justMinted)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.justMint")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nftRequestPhotos, (photo, key) => {
                return (_openBlock(), _createElementBlock("div", { key: key }, [
                  (photo.status == 'init' || photo.status == 'mint')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("img", {
                          src: photo.photoURL,
                          class: "mt-4 w-48 rounded-xl"
                        }, null, 8, _hoisted_18),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("label.creator")) + ":" + _toDisplayString(_ctx.shortID(photo.creator)), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("label.name")) + ":" + _toDisplayString(photo.title), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("label.description")) + ":" + _toDisplayString(photo.description), 1),
                        _createElementVNode("p", null, [
                          (photo?.status == 'init' && _ctx.hasAuthorityToken)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.mint(photo.creator, photo.photoId)),
                                class: "inline-block px-6 py-2.5 bg-green-600 text-white leading-tight rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out"
                              }, _toDisplayString(_ctx.$t("label.mint")), 9, _hoisted_19))
                            : (_openBlock(), _createElementBlock("button", _hoisted_20, [
                                (photo?.status == 'init')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("label.mintNotHasAuthority")), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                      _hoisted_23,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t("label.minting")), 1)
                                    ])),
                                _hoisted_24
                              ])),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("message.mintCaution")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}